import loadable from '@loadable/component';

export const CmsCtaHeroBlockLoadable = loadable(
  () => import('./CmsCtaHeroBlock'),
  { resolveComponent: (module) => module.CmsCtaHeroBlock },
);
